import { PROXIED_ORIGINS, PROXY_ORIGIN_TO_PREFIX } from './getProxyOrigin';

/**
 * Converts a relative dashboard path into a relative dashboard path with the Zillow domain prefix
 */
export const getZillowPath = (localPath: string): string =>
    `${PROXY_ORIGIN_TO_PREFIX[PROXIED_ORIGINS.ZILLOW]}${localPath}`;
